import { DESKTOP_SIGNUP_MODAL_IMAGERY_2024_SEP } from "@faire/web-api/indigofair/settings/DESKTOP_SIGNUP_MODAL_IMAGERY_2024_SEP";

import { useSetting } from "./__internal__/useSetting";

export const useSettingDesktopSignUpModalImagery = ():
  | "BUCKET_UNKNOWN"
  | "CONTROL"
  | "VARIANT_2"
  | "VARIANT_3" => useSetting(DESKTOP_SIGNUP_MODAL_IMAGERY_2024_SEP, "CONTROL");

export const useIsSettingSignUpImageryTreatment = () => {
  const settingSignUpImageryVariant = useSettingDesktopSignUpModalImagery();
  return (
    settingSignUpImageryVariant === "VARIANT_2" ||
    settingSignUpImageryVariant === "VARIANT_3"
  );
};
